const useStyles = theme => ({
    smallCarouselItem: {
      width: '100%'
    },
});

export default useStyles
